import React from 'react'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'
import {
  WebsiteLogoImageUi,
  WebsiteLogoTextUi,
  WebsiteLogoWrapperUi,
} from './ui'

interface WebsiteLogoProps extends WebsiteLogoInterface {
  imageSrc: string
  mobileImageSrc: string
  alt?: string
}

export const WebsiteLogo = (props: WebsiteLogoProps) => {
  return (
    <WebsiteLogoWrapperUi id={props.htmlAttrId}>
      <WebsiteLogoTextUi
        {...props}
        color={props.textColor}
        imageSrc={props.imageSrc}
        mobileImageSrc={props.mobileImageSrc}
      >
        {props.logoText}
      </WebsiteLogoTextUi>

      <WebsiteLogoImageUi
        alt={props.alt ?? props.logoText ?? ''}
        imageSrc={props.imageSrc}
        mobileImageSrc={props.mobileImageSrc}
      />
    </WebsiteLogoWrapperUi>
  )
}
